import React, { memo, useEffect } from "react";
import FuelCompositionInput from "./FuelCompositionInput";
import ContentFrame from "components/ContentFrame/ContentFrame";

import { useDispatch, useSelector } from "react-redux";
import { FormItem, StoreState } from "models";
import { setFormItemValue, loadDefaults } from "redux/FuelComposition/FuelComposition.actions";

import { makeStyles, createStyles } from "@material-ui/styles";
import { ValmetGrey15, ValmetGrey10 } from "theme";

const localStyles = makeStyles(() =>
  createStyles({
    form: {
      margin: "0 auto",
    },
    formFooter: {
      display: "flex",
      marginTop: "2rem",
      alignContent: "center",
      justifyContent: "center",
      flexDirection: "column",
      alignItems: "center",
    },
    submitButton: {
      border: `1px solid ${ValmetGrey10}`,
      backgroundColor: ValmetGrey15,
      borderRadius: "3px",
      padding: "10px",
    },
    buttonActive: {
      cursor: "pointer",
    },
    buttonInProgress: {
      cursor: "progress ",
    },
    label: {
      fontSize: "13px",
    },
  }),
);

const FuelCompositionForm: React.FC = () => {
  const localClasses = localStyles();
  const dispatch = useDispatch();

  const fetchingMills = useSelector((state: StoreState) => state.millSelector.fetching);
  const fetchingMillsInvalidated = useSelector((state: StoreState) => state.millSelector.didInvalidate);
  const submitting = useSelector((state: StoreState) => state.fuelComposition.submitPending);
  const formItems: FormItem[] = useSelector((state: StoreState) => state.fuelComposition.data);

  useEffect(() => {
    if (!formItems.length) {
      dispatch(loadDefaults());
    }
  }, [dispatch, formItems]);

  const handleValueChange = (id: string, value: string) => {
    dispatch(setFormItemValue(id, parseFloat(value)));
  };

  return (
    <ContentFrame title="As Fired - Black Liquor Dry Solids Composition">
      <form className={localClasses.form}>
        {formItems.map((item) => (
          <FuelCompositionInput
            key={item.id}
            id={item.id}
            title={item.title}
            min={item.min}
            isValid={item.valid}
            loading={fetchingMills || submitting}
            isDisabled={fetchingMillsInvalidated}
            value={item.value}
            handleValueChange={handleValueChange}
          />
        ))}
      </form>
    </ContentFrame>
  );
};

export default memo(FuelCompositionForm);
